import React from 'react';
import { Match as ReactRouterMatch, Redirect } from 'react-router';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';

const logPageView = (location) => {
  if (location === '/') { location = '/properties'; }
  ReactGA.set({ page: location });
  ReactGA.pageview(location);
};

const haveAccess = (viewer, authorized) => authorized ? viewer : true;

const Match = ({ authorized, component: Component, render, viewer, ...props }) => (
  <ReactRouterMatch
    {...props}
    render={(renderProps) => {
      logPageView(props.pattern);
      return (
        haveAccess(viewer, authorized) ?
          render ? render(renderProps) : <Component {...renderProps} />
        :
          <Redirect
            to={{
              pathname: '/',
              state: { from: renderProps.location },
            }}
          />
      );
    }}
  />
);

Match.propTypes = {
  authorized: React.PropTypes.bool,
  component: React.PropTypes.func,
  render: React.PropTypes.func,
  viewer: React.PropTypes.object,
  pattern: React.PropTypes.string,
};

export default connect(
  (state: State) => ({
    viewer: state.users.viewer,
  }),
)(Match);



// WEBPACK FOOTER //
// ./src/common/app/components/Match.js